import React, { useState, useEffect, useCallback } from 'react';
import { Provider } from 'react-redux';
import store from '../../../state';
import ContextMenu from './ContextMenu';

// this is the version of the context menu that is linked to the table schedule
// component. When right clicking on an interval, the context menu displays.
// When a change is made, the relevant parts of the table schedule are
// refreshed.
const StandAlone = ({ groupId }) => {
  // use one state variable to avoid multiple updates of the underlying
  // components
  const [intervalData, setIntervalData] = useState({
    startTime: null,
    endTime: null,
    ownerId: null,
    ownerType: null
  });

  const [xCoord, setXCoord] = useState(null);
  const [yCoord, setYCoord] = useState(null);
  const [show, setShow] = useState(false);

  const displayContextMenu = useCallback(
    event => {
      // but only care about those that right click on editable intervals
      const target = event.target.closest('.schedule-interval.availability-editable');

      if (!target) return;

      event.preventDefault();
      setXCoord(event.pageX);
      setYCoord(event.pageY);

      const data = {
        ...target.dataset,
        assignedFunctionIds: target.dataset.assignedFunctionIds ? target.dataset.assignedFunctionIds.split(',') : []
      };

      setIntervalData(data);
      setShow(true);
    },
    [setXCoord, setYCoord, setIntervalData, setShow]
  );

  const hideContextMenu = useCallback(() => {
    setShow(false);
  }, [setShow]);

  useEffect(() => {
    document.addEventListener('click', hideContextMenu);
    document.addEventListener('scroll', hideContextMenu);

    // attach an event listerener to the document. When clicked on a
    // .schedule-interval.availability-editable, display the context menu
    document.addEventListener('contextmenu', displayContextMenu);

    return () => {
      document.removeEventListener('click', hideContextMenu);
      document.removeEventListener('scroll', hideContextMenu);

      document.addEventListener('contextmenu', displayContextMenu);
    };
  }, [displayContextMenu, hideContextMenu]);

  // notify the tableScheduleManager that changes have happened during the
  // indicated period
  const notifyChanged = (st = intervalData.startTime, et = intervalData.endTime) => {
    setShow(false);
    globalThis.tableScheduleManager.reloadPeriod(st.fromISOString(), et.fromISOString());
  };

  const setLoading = () => {
    globalThis.tableScheduleManager.setLoading(
      intervalData.startTime.fromISOString(),
      intervalData.endTime.fromISOString()
    );
  };

  return (
    <Provider store={store}>
      <ContextMenu
        groupId={groupId}
        xCoord={xCoord}
        yCoord={yCoord}
        startTime={intervalData.startTime}
        endTime={intervalData.endTime}
        ownerId={intervalData.ownerId}
        ownerType={intervalData.ownerType}
        assignedFunctionIds={intervalData.assignedFunctionIds}
        notifyChanged={notifyChanged}
        show={show}
        setLoading={setLoading}
      />
    </Provider>
  );
};

export default StandAlone;
